var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{style:(_vm.customStyle),attrs:{"clearable":"","placeholder":"选择场次","value":_vm.interval_time,"disabled":_vm.disabled},on:{"change":_vm.changeInterval}},_vm._l((_vm.timeOptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }